import { render, staticRenderFns } from "./RoleActions.vue?vue&type=template&id=56b92998&scoped=true"
import script from "./RoleActions.vue?vue&type=script&lang=js"
export * from "./RoleActions.vue?vue&type=script&lang=js"
import style0 from "./RoleActions.vue?vue&type=style&index=0&id=56b92998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b92998",
  null
  
)

export default component.exports